// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import columns from './columns'
import SimpleCell from './SimpleCell'

const SegmentEndInfo = ({ idRoot, segmentEndData }) => (
  <>
    {
      columns.map(d => (
        <SimpleCell
          key={d.columnKey}
          id={`${idRoot}-${d.columnKey}`}
          value={segmentEndData[d.columnKey]} />
      ))
    }
  </>
)

SegmentEndInfo.propTypes = {
  idRoot: string.isRequired,
  segmentEndData: object.isRequired,
}

export default SegmentEndInfo
